import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const content: ThemeUICSSObject = {
  height: '100%',

  '& > iframe, & > iframe > iframe': {
    height: '100%',
    width: '100%',
    border: 'none',
  },
  /* PREPEND HERE */
};

export default content;
